import { EacFunds } from 'shared/models';

export class EACRequest {
    public portfolioTypeId: number;
    public funds: EacFunds[];
    public transactionId: string;
}
